import { passCodes } from '../passCodes';
import cipher19Hint2 from '../../../../assets/images/games/zdar-escape-game/ciphers/19/hint2.webp';
import cipher19Image from '../../../../assets/images/games/zdar-escape-game/ciphers/19/image9.webp';
import track19 from '../../../../assets/audio/tracks/track19.mp3';

const hints = [
    {
        text: 'Jděte rovně a rozcestník je na tyči.',
    },
    {
        image: cipher19Hint2,
    },
    {
        text: 'Kódem je: U křížku',
        solution: true,
    },
];
export const step19crossroads = {
    id: 18,
    title: '7. stanoviště',
    taskText: `
        <p>
            Tak teď se můžeme vrátit asi kde jsme skončili co? Hmm koukej támhle je rozcestník. Na ty většinou lidé koukají, když chtějí vědět kam jít že? Tak se na něj mrkneme.
        </p>
    `,
    catImage: 2,
    audio: track19,
    snowAudio: track19,
    cipher: {
        label: 'Úkol',
        text: `
            <p>
                Vraťte se zpátky na místo, kde jste skončili (k mostu z poslední fotky). V okolí 150m hledejte rozcestník.
            </p>
            <p>
                Pokud stojíte u rozcestníku, zadejte kam vede trasa dlouhá 2,5 km.
            </p>
            <p>
                Pokud nemůžete rozcestník najít, zkuste použít nápovědu.
            </p>
        `,
        images: [cipher19Image],
    },
    codeInputText: 'Zadejte název',
    codeInputPassCodeRegexp: passCodes[12],
    hints: hints,
    snowHints: hints,
};
